import { useEffect } from 'react';

const IOS_UA = /iPad|iPhone|iPod/i;

export const useIosNoInputZoom = (): void => {
  useEffect(() => {
    if (!IOS_UA.test(navigator.userAgent)) {
      return;
    }
    const viewport = document.querySelector<HTMLMetaElement>(
      'meta[name="viewport"]'
    );
    if (viewport && !viewport.content.includes('maximum-scale')) {
      viewport.content = `${viewport.content}, maximum-scale=1`;
    }
  }, []);
};
